<h3>Forgot Password</h3>

<form (ngSubmit)="doSendOtp()" [formGroup]="form" *ngIf="mode == 'CaptureUsername'">
	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="username" placeholder=" " formControlName="username" />
		<label for="username">Username</label>
	</div>
	<button type="submit" class="btn btn-primary">Send OTP</button>
</form>

<form (ngSubmit)="doSendOtp()" [formGroup]="form" *ngIf="mode == 'ResetPassword'">
	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="username" placeholder=" " formControlName="username" [readOnly]="true" />
		<label for="username">Username</label>
	</div>
	<div class="form-floating mb-4 position-relative">
		<input text class="form-control" id="otp" placeholder=" " formControlName="OTP" />
		<label for="otp">OTP</label>
	</div>
	<div class="form-floating mb-4 position-relative">
		<input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" placeholder=" " formControlName="password" />
		<label for="password">Password</label>
	</div>
	<div class="form-floating mb-4 position-relative">
		<input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" id="confirmPassword" placeholder=" " formControlName="confirmPassword" />
		<label for="confirmPassword">Confirm Password</label>
	</div>
	<div class="d-grid" *ngIf="message">
		<div class="alert alert-warning">
			{{message}}
		</div>
	</div>
	<div class="d-grid">
		<button type="submit" class="btn btn-primary rounded-3">
			Reset Password
		</button>
	</div>
</form>
